import { render, staticRenderFns } from "./CompetitionListAwardLayout.vue?vue&type=template&id=6f4f195e&scoped=true&"
import script from "./CompetitionListAwardLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionListAwardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f195e",
  null
  
)

export default component.exports